const studentChangelogState = {
  url: 'changelog/',
  template: '<changelog></changelog>',
  data: {
    pageTitle: 'Feedback History'
  }
};

export const ApChangelogRoutes = {
  'my.planner.changelog': { ...studentChangelogState }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_changelog_routes.ts